import { ChevronDownIcon } from "@heroicons/react/16/solid";
import countries from "../../data/countries";
import { useState } from "react";
import { useEffect } from "react";

export default function PhoneInput({
	countryCodes,
	onCountryCodeChange,
	onPhoneNumberChange,
	phoneNumber,
	countryCode,
	disabled = false,
	handleNext,
	step,
}) {
	return (
		<div className="font-poppins">
			<label
				htmlFor="phone-number"
				className="block text-sm/6 font-medium text-gray-900"
			>
				Phone number
			</label>
			<div className="mt-0 space-y-2">
				{/* Country Selector Row */}
				<div className="flex rounded-md outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
					<div className="grid shrink-0 grid-cols-1 focus-within:relative w-full">
						<select
							disabled={disabled}
							id="country"
							name="country"
							autoComplete="country"
							aria-label="Country"
							value={countryCode}
							className={`w-full appearance-none rounded-md py-1.5 pl-3 pr-7 text-base text-gray-500 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 ${
								disabled ? "bg-neutral-200" : "bg-white"
							}`}
							onChange={(e) => onCountryCodeChange(e)}
						>
							{countries.map((_country) => (
								<option
									key={_country.name + _country.code}
									value={`${_country.name} ${_country.code}`}
								>
									{_country.name} ({_country.code})
								</option>
							))}
						</select>
					</div>
				</div>

				{/* Phone Number Input Row */}
				<div className="flex rounded-md outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
					<input
						disabled={disabled}
						id="phone-number"
						name="phone-number"
						placeholder="Phone Number"
						type="tel"
						requirepattern="[0-9]{10}"
						title="Please enter a 10-digit phone number"
						minLength={10}
						maxLength={15}
						required
						onChange={(e) => onPhoneNumberChange(e)}
						value={phoneNumber}
						className={`block w-full rounded-md py-1.5 pl-3 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6 ${
							disabled ? "bg-neutral-200" : "bg-white"
						}`}
					/>
				</div>
				{/**step == 1 && (
          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleNext}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Next
            </button>
          </div>
        )*/}
			</div>
		</div>
	);
}
